import { HttpType } from 'utils/http';
import { shareLightUrls } from 'utils/apiUrls';

export const fetchPendingShareYourLight = (method: HttpType['get']) => function async() {
  return method(shareLightUrls.pending.apiUrl().list, {});
};

export const approveShareYourLight = (method: HttpType['post'], body: {id: string, is_approved: boolean }) => method(shareLightUrls.approve.apiUrl().approve, body);

export default fetchPendingShareYourLight;
